export const getIngredients = state => state.ingredients.ingredients;
